import React, { Component } from 'react'
import styled from 'styled-components'
import Banner from '../../Calculator/Banner'
import Button from '../../UI/Button'
import qs from 'qs'
import { Wrapper, Caret } from './Step0'
import { device } from '../../../utils/helpers'
import RecapTable from '../../Calculator/Table'
import PurchaseForm from '../../Forms/Purchase'

const Content = styled.div`
  margin-top: 15px;

  @media ${device.tablet} {
    display: flex;
    justify-content: space-between;
    margin-top: 0.78125vw;
  }
`

const TableSection = styled.div`
  @media ${device.tablet} {
    width: 49%;
  }
`

const FormSection = styled.div`
  @media ${device.tablet} {
    width: 49%;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.color.bgYellow};
  justify-content: center;
  padding: 25px 20px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: 'BarlowSemiBold';
  color: #fff;
  font-size: 18px;

  @media ${device.tablet} {
    margin-top: 0;
    font-size: 1.25vw;
    ${''/* padding: 25px 20px; */}
    padding: 1.3020833333333335vw 1.0416666666666667vw;
    margin-bottom: 0.78125vw;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

class Step7 extends Component {
  render () {
    const { sport } = this.props.match.params // Sport token from URL
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    return (
      <Wrapper>
        <Banner
          title='LA TUA CONFIGURAZIONE'
        />
        <Content>
          <TableSection>
            <RecapTable />
          </TableSection>
          <FormSection>
            <Info>
              INSERISCI I TUOI DATI PER SALVARE IL PREVENTIVO <br /> ED ESSERE RICONTATTATO
            </Info>
            <PurchaseForm />
          </FormSection>
        </Content>
        <ButtonWrapper>
          <Button to={`/noleggia/${sport}/6?variant=${currentVariant}`} size='small'><Caret transform='rotate(180)' fill='#fff' /> &nbsp;&nbsp; STEP PRECEDENTE</Button>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}

export default Step7



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step7.js